import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getUsernames = (data: PropertyType): Promise<PropertyType> =>
	api.post('/user/usernames', mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
